import { useMemo } from 'react'

import { MainContent, TopBar } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useFilters from '@hooks/useFilters'
import useMainNavigation from '@hooks/useMainNavigation'

import LoggedInUser from '@components/LoggedInUser'
import MainNavigation from '@sections/Admin/components/MainNavigation'

import PageContent from './components/PageContent'

const OrdersList = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()

  const filtersPayload = useFilters({ persistFilters: true })

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    defaultFiltersModifiedAt,
    pageFilters,
  } = filtersPayload

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
    },
    defaultFilters,
  }), [defaultFiltersModifiedAt])

  return (
    <>
      <TopBar
        callbacks={{ toggleNavigation }}
        loggedInUserComponent={<LoggedInUser />}
        searchComponent={<TopBar.Search callbacks={{ search: null }} />}
      />

      <MainNavigation />

      <MainContent offset={{ top: TopBar.topBarHeight }}>
        <PageContext.Provider value={pageContext}>
          <PageContent pageFilters={pageFilters} />
        </PageContext.Provider>
      </MainContent>
    </>
  )
}

export default OrdersList
